// import React from "react";
// import "./PlatformFeatures.css";

// const featuresData = [
//   {
//     title: "Core HRMS",
//     desc: "Employee management, directory, workflows, self-service, document management",
//     icon: "👥",
//   },
//   {
//     title: "Attendance",
//     desc: "Monitor attendance, schedule smart shifts, and make many attendance methods possible.",
//     icon: "📅",
//   },
//   {
//     title: "Leave Management",
//     desc: "Configure every type of leave policy and use leave dashboards and reports for tracking.",
//     icon: "💰",
//   },
//   {
//     title: "Payroll",
//     desc: "End-to-end payroll processing, taxing, benefits tracking, exemptions, User Payslip.",
//     icon: "🧾",
//   },
//   {
//     title: "Task Management",
//     desc: "Plan tasks, track and complete them efficiently, delegate task and set reminders.",
//     icon: "📋",
//   },
//   {
//     title: "Performance Management",
//     desc: "Staff evaluations, goal setting, talent management and ongoing 360-degree feedback.",
//     icon: "📊",
//   },
//   {
//     title: "Onboarding",
//     desc: "Acquire talents, skills and have a smooth run for employees from day one.",
//     icon: "🛡️",
//   },
//   {
//     title: "Recruitment",
//     desc: "AI enabled engine for hiring, skill set matches, tracking interviews and feedback.",
//     icon: "🧲",
//   },
// ];

// const PlatformFeatures = () => {
//   return (
//     <section className="pf-wrapper">
//       <div className="pf-header">
//         <h2>PLATFORM FEATURES</h2>
//         <p>Everything you need to create a high-performance culture</p>
//       </div>

//       <div className="pf-grid">
//         {featuresData.map((item, index) => (
//           <div className="pf-card" key={index}>
//             <div className="pf-icon-box">{item.icon}</div>

//             <h3 className="pf-title">{item.title}</h3>
//             <p className="pf-desc">{item.desc}</p>

//             <a href="/" className="pf-link">
//               Explore more →
//             </a>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// };

// export default PlatformFeatures;



import React, { useState } from "react";
import "./PlatformFeatures.css";

const featureSets = {
    hrm: [
        {
            title: "Core HRMS",
            desc: "Employee management, directory, workflows, self-service, document management",
            icon: "👥",
        },
        {
            title: "Attendance",
            desc: "Monitor attendance, schedule smart shifts, and make many attendance methods possible.",
            icon: "📅",
        },
        {
            title: "Leave Management",
            desc: "Configure every type of leave policy and use leave dashboards and reports for tracking.",
            icon: "💰",
        },
        {
            title: "Payroll",
            desc: "End-to-end payroll processing, taxing, benefits tracking, exemptions, User Payslip.",
            icon: "🧾",
        },
        {
            title: "Task Management",
            desc: "Plan tasks, track and complete them efficiently, delegate task and set reminders.",
            icon: "📋",
        },
        {
            title: "Performance Management",
            desc: "Staff evaluations, goal setting, talent management and ongoing 360-degree feedback.",
            icon: "📊",
        },
        {
            title: "Onboarding",
            desc: "Acquire talents, skills and have a smooth run for employees from day one.",
            icon: "🛡️",
        },
        {
            title: "Recruitment",
            desc: "AI enabled engine for hiring, skill set matches, tracking interviews and feedback.",
            icon: "🧲",
        },
    ],


    finance: [
        {
            title: "Salary Structure",
            desc: "Define salary components like Basic, HRA, Allowances, deductions and gross structure.",
            icon: "💼",
        },
        {
            title: "Payroll Processing",
            desc: "Automated monthly payroll with salary calculation, arrears and adjustments.",
            icon: "💰",
        },
        {
            title: "Payslip Management",
            desc: "Generate, download and distribute employee payslips securely.",
            icon: "🧾",
        },
        {
            title: "PF Management",
            desc: "Provident Fund calculation, employer & employee contribution and reports.",
            icon: "🏦",
        },
        {
            title: "PT Management",
            desc: "Professional Tax calculation based on state-wise slabs.",
            icon: "📑",
        },
        {
            title: "Income Tax",
            desc: "Income tax computation, exemptions, declarations and Form 16.",
            icon: "📊",
        },
        {
            title: "Statutory Compliance",
            desc: "Manage statutory compliance, challans and regulatory reports.",
            icon: "⚖️",
        },
        {
            title: "Payroll Reports",
            desc: "Salary register, deduction reports, compliance and audit-ready exports.",
            icon: "📈",
        },

    ],

    admin: [
        {
            title: "Admin Dashboard",
            desc: "Centralized dashboard with system analytics, user stats and activity monitoring.",
            icon: "🛠️",
        },
        {
            title: "Company Directory",
            desc: "Organization-wide employee directory with departments, roles and contact details.",
            icon: "🏢",
        },
        {
            title: "User & Role Management",
            desc: "Create users, assign roles, manage permissions and access control.",
            icon: "🔐",
        },
        {
            title: "Employee Profiles",
            desc: "Detailed employee profiles with personal, professional and document information.",
            icon: "👤",
        },
        {
            title: "Attendance Oversight",
            desc: "Admin and manager-level attendance monitoring, approvals and corrections.",
            icon: "📅",
        },
        {
            title: "Payroll Control",
            desc: "Payroll approvals, salary revisions, compliance verification and audit logs.",
            icon: "💰",
        },
        {
            title: "Manager Tools",
            desc: "Team performance insights, approvals, goal tracking and team analytics.",
            icon: "📈",
        },
        {
            title: "Task Management",
            desc: "Assign, track, prioritize tasks and monitor progress across teams.",
            icon: "✅",
        },
        {
            title: "Ticketing & Support",
            desc: "Internal ticketing system for HR, IT and admin support requests.",
            icon: "🎫",
        },
        {
            title: "Vendor Management",
            desc: "Vendor onboarding, contracts, invoices, compliance and payment tracking.",
            icon: "🏬",
        },
        {
            title: "Document Management",
            desc: "Central repository for company policies, contracts and employee documents.",
            icon: "📁",
        },
        {
            title: "Reports & Audit Logs",
            desc: "System reports, activity logs and audit-ready exports for compliance.",
            icon: "📊",
        },
    ],

};

const PlatformFeaturesTabs = () => {
    const [activeTab, setActiveTab] = useState("hrm");

    return (
        <section className="pft-wrapper">
            {/* ===== Heading ===== */}
            <div className="pft-header">
                <h2 className="pft-heading">
                    OUR PLATFORM <span>FEATURES</span>
                </h2>

                <div className="pft-underline"></div>

                {/* <p>Everything you need to run HR, Finance & Operations seamlessly</p> */}
            </div>


            {/* ===== Tabs ===== */}
            <div className="pft-tabs">
                <span
                    className={`pft-tab ${activeTab === "hrm" ? "active" : ""}`}
                    onClick={() => setActiveTab("hrm")}
                >
                    HRM
                </span>
                <span
                    className={`pft-tab ${activeTab === "finance" ? "active" : ""}`}
                    onClick={() => setActiveTab("finance")}
                >
                    Finance
                </span>
                <span
                    className={`pft-tab ${activeTab === "admin" ? "active" : ""}`}
                    onClick={() => setActiveTab("admin")}
                >
                    Admin / Manager / Vendor
                </span>
            </div>

            {/* ===== Feature Cards ===== */}
            <div className="pft-grid fade-in">
                {featureSets[activeTab].map((item, index) => (
                    <div className="pft-card" key={index}>
                        <div className="pft-icon">{item.icon}</div>
                        <h3>{item.title}</h3>
                        <p>{item.desc}</p>
                        <span className="pft-link">Explore more →</span>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default PlatformFeaturesTabs;

